import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import AuthShell, { inputCls, labelCls } from "./AuthShell";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { startCheckout } from "@/lib/checkout";
import { useSeo } from "@/lib/seo";

export default function Login() {
  useSeo({ title: "Sign In | Infant Sleep Consultant Near Me Education Center", noindex: true });
  const { login } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const u = await login(email, password);
      const pending = ["diagnostic", "blueprint", "guided", "guided_standalone", "inhome_overnight", "is101_tuition", "ns101_tuition", "is201_tuition", "is301_tuition", "is401_tuition"].includes(sp.get("product")) ? sp.get("product") : null;
      const rawNext = sp.get("next") || "";
      if (pending && u.role === "customer") {
        localStorage.removeItem("isc_pending_product");
        return startCheckout({ product: pending, user: u, navigate: nav });
      }
      if (u.role === "customer" && rawNext.startsWith("/") && !rawNext.startsWith("//")) return nav(rawNext);
      nav(u.role === "admin" ? "/admin" : u.role === "operator" ? "/operator" : "/portal");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Welcome back" subtitle="Sign in to your portal to continue where you left off."
      footer={<>New student? <Link to={sp.get("next") ? `/register?next=${encodeURIComponent(sp.get("next"))}` : "/register"} data-testid="login-register-link" className="text-[#C2836B] hover:underline">Create your student account</Link></>}>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className={labelCls}>Email</label>
          <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} required />
        </div>
        <div>
          <label className={labelCls}>Password</label>
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} required />
        </div>
        {err && <p data-testid="login-error" className="text-[#e08a8a] text-sm">{err}</p>}
        <button data-testid="login-submit" disabled={busy} className="btn-clay w-full py-3 rounded-full text-sm disabled:opacity-60">{busy ? "Signing in…" : "Sign In"}</button>
        <div className="text-center"><Link to="/forgot-password" className="text-sm text-[#738075] hover:text-[#A39E98]">Forgot password?</Link></div>
      </form>
    </AuthShell>
  );
}
